/**
 * webRTCConnectionActions.js
 * Talkroute
 *
 * Created by Vel Genov on 11/6/19
 * Copyright (c) 2019 Talkroute. All right reserved.
 */
import apiServiceInstance from "../services/TalkrouteAPIService";

/**
 * Constants for the different redux action types
 */
export const CONNECTION_DATA_FETCH_STARTED = "CONNECTION_DATA_FETCH_STARTED";
export const CONNECTION_DATA_FETCH_SUCCESS = "CONNECTION_DATA_FETCH_SUCCESS";
export const CONNECTION_DATA_FETCH_FAILURE = "CONNECTION_DATA_FETCH_FAILURE";

/**
 * Gets the webRTC connection data from a web service
 */
export const fetchConnectionData = () => {
  return (dispatch) => {
    dispatch(connectionDataFetchBegin());
    return apiServiceInstance
      .fetchWebRTCConnectionData()
      .then((data) => {
        // Sort data by date
        dispatch(connectionDataFetchSuccess(data));
        return data;
      })
      .catch((error) => dispatch(connectionDataFetchFailure(error)));
  };
};

/**
 * Started fething webrtc connection data
 */
export const connectionDataFetchBegin = () => ({
  type: CONNECTION_DATA_FETCH_STARTED,
});

/**
 * Successfully fetched webrtc connection data
 */
export const connectionDataFetchSuccess = (data) => ({
  type: CONNECTION_DATA_FETCH_SUCCESS,
  payload: { data },
});

/**
 * An error occured while fetching webrtc connection data
 * @param {*} error
 */
export const connectionDataFetchFailure = (error) => ({
  type: CONNECTION_DATA_FETCH_FAILURE,
  payload: { error },
});

const webRTCConnectionActions = {
  fetchConnectionData,
  connectionDataFetchBegin,
  connectionDataFetchSuccess,
  connectionDataFetchFailure,
};

export default webRTCConnectionActions;
